import { useEffect, useState } from "react";
import { Card, CardContent } from "../components/ui/card";
import { useNavigate } from "react-router-dom";
import { API } from "../config";
import { Menu } from "../components/ui/menu";
import { useProfile } from "../context/ProfileContext";
import { HistoryViewer } from "../components/ui/history";
import CollapsibleCard from "../components/ui/accordion";
import { parseDate } from "../helpers/date";
import { cleanUp } from "../helpers/logout";
import Impersonate from "../components/ui/impersonate";

export default function MembershipPage() {
  const { profile, loading, identifier, token } = useProfile();
  const [response, setResponse] = useState<any>(null);
  const [historyOne, setHistoryOne] = useState<any>(null);
  const [historyMembersOne, setHistoryMembersOne] = useState<any>(null);
  const [sortedKeys, setSortedKeys] = useState<any>(null);
  const [history, setHistory] = useState<any>(null);
  const [historyServices, setHistoryServices] = useState<any>(null);
  const [tariffs, setTariffs] = useState<any>(null);
  const [account, setAccount] = useState<any>(null);
  const [counters, setCounters] = useState<any>(null);
  const [membership, setMembership] = useState<any>(null);
  const [section, setSection] = useState<any>(null);
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [impersonate, setImpersonate] = useState<string>("");
  const [impersonateMessage, setImpersonateMessage] = useState<string>("");
  const [showLoading, setShowLoading] = useState<Boolean>(false);

  useEffect(() => {
    setShowLoading(loading);
  }, [loading]);

  useEffect(() => {
    let impersonate: string | null = null;
    try {
      impersonate = localStorage.getItem("impersonate");
    } catch (e) {
      console.error("Error reading impersonate from localStorage:", e);
      impersonate = null; // Default to null if there's an error
    }
    if (impersonate) {
      setImpersonate(impersonate);
      setImpersonateMessage(`Обліковий запис ${impersonate}`);
    }
  }, []);

  useEffect(() => {
    if (!identifier && !token) {
      navigate("/login" + window.location.search);
      return;
    }

    if (!identifier) {
      return;
    }

    setShowLoading(true);
    const params = new URLSearchParams();
    let impersonate: string | null = null;
    try {
      impersonate = localStorage.getItem("impersonate");
    } catch (e) {
      console.error("Error reading impersonate from localStorage:", e);
      impersonate = null; // Default to null if there's an error
    }
    if (impersonate) {
      setImpersonate(impersonate);
      params.append("i", impersonate);
    }
    fetch(API.RECORD(identifier) + `${params ? "?" + params : ""}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => {
        if (res.status === 401) {
          cleanUp();
          navigate("/login" + window.location.search);
        }
        if (res.status !== 200) {
          return res.body;
        }
        return res?.json()
      })
      .then((res) => {
        setResponse(res);
        setSection(res?.section);
        setAccount(res?.account);
        setCounters(res?.counters);

        const sortedKeys = Object.keys(res?.history?.records || {});
        sortedKeys.sort((keyA, keyB) => parseDate(keyA).getTime() - parseDate(keyB).getTime());
        sortedKeys.reverse()
        setSortedKeys(sortedKeys);
        const lastKey = sortedKeys?.[0];
        setHistory(res?.history?.records);
        setHistoryServices(res?.history?.services || {});
        setHistoryOne({ [lastKey]: res?.history?.records?.[lastKey] || {} });
        sortedKeys.some((key: string) => {
          const records = res?.history?.records?.[key];
          const firstValue: Record<string, any[]> = { [key]: [] }
          records.map((record: any) => {
            if (record?.service !== "electricity") {
              firstValue[key].push(record);
            }
          })
          if (firstValue?.[key]?.length > 0) {
            setHistoryMembersOne(firstValue);
            return true;
          }
          return false;
        })

        const membershipEntries: any = {};
        Object.keys(res?.membership).reverse().map((key) => {
          const entry = res?.membership?.[key];
          const firstYear = Object.keys(entry?.["years"])?.[0] || "0000";
          if (!membershipEntries[firstYear]) {
            membershipEntries[firstYear] = [];
          }
          membershipEntries[firstYear].push(entry);
        });
        setMembership(membershipEntries);

        const tariffs: {[key: string]: Object} = {};
        Object.keys(res?.tariffs || {}).forEach((tp: string) => {
          const tariffDates: {[key: string]: Date} = {};
          const tKeys = Object.keys(res?.tariffs?.[tp] || {});
          tKeys.sort((keyA, keyB) => parseDate(keyA).getTime() - parseDate(keyB).getTime());
          tKeys.reverse()
          Object.values(tKeys).forEach((date: string) => {
            tariffDates[date] = new Date(date)
          })
          const sortedTariffs = Object.keys(tariffDates).sort((a, b) => {
            return tariffDates[b].getTime() - tariffDates[a].getTime();
          });
          tariffs[tp] = res?.tariffs[tp][sortedTariffs?.[0]];
        })
        setTariffs(tariffs || []);
      }).catch((err) => {
      if (err.status === 401) {
        cleanUp();
        navigate("/login" + window.location.search);
      }
      console.error("Помилка сервера", err || "");
      setError("Помилка сервера")
      setTimeout(() => setError(""), 5000);
    }).finally(() => {
      setShowLoading(false);
    });
  }, [identifier, token, navigate]);

  if (showLoading) return <Menu><p className="text-center p-4">Завантажується...</p></Menu>;

  return (
    <Menu>
      <div className="flex flex-col">
        <Impersonate message={impersonateMessage} callbackExit={() => {
          try {
            localStorage.removeItem("impersonate");
          } catch (e) {
            console.error("Error removing impersonate from localStorage:", e);
          }
          setImpersonateMessage("");
          navigate("/users");
        }}/>
        {error && <p className="text-red-500 text-sm text-center">{error}</p>}
        {history && (
          <Card className="w-full max-w-4xl rounded-2xl shadow-md mb-1">
            <CardContent>
              <CollapsibleCard title={"Історія Членських та Послуг"} open={true} more={false}>
                <HistoryViewer history={history} account={account} title={""}
                               excludeKeys={["electricity"]}
                               includeNames={[""]}
                               excludeNames={["!член"]}
                               sortedKeys={sortedKeys}
                               openState={true}
                />
              </CollapsibleCard>
            </CardContent>
          </Card>
        )}
      </div>
    </Menu>
  );
}
